// extracted by mini-css-extract-plugin
export default {"ProductInfo":"styles_ProductInfo__dBSdu","ProducerName":"styles_ProducerName__rhHsG","LinkToZoom":"styles_LinkToZoom__Zqlsy","ProductName":"styles_ProductName__H6Kit"};